import React from 'react'

import { ContentSection } from 'src/common/components/ContentSection/ContentSection'
import { PageStartupBlock } from 'src/common/pageBlocks/PageStartupBlock/PageStartupBlock'

import { DOMAIN_OR_SKILL_STARTUP_ITEMS } from './domainOrSkillStartupItems'

export type DomainOrSkillStartupBlockProps = {
  name: string
}

export const DomainOrSkillStartupBlock: React.FC<
  DomainOrSkillStartupBlockProps
> = ({ name }) => {
  const title = `Hire senior startup ${name} developers`

  return (
    <ContentSection>
      <PageStartupBlock
        title={title}
        items={DOMAIN_OR_SKILL_STARTUP_ITEMS}
        pageAnalytic={'domain or skill'}
      />
    </ContentSection>
  )
}
